<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class.d-none]="showCharts"
  [config]="pageConfig"
  [title]="'pages.sendSmartSMS.detail' | translate"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  [defaultFilters]="defaultFilters"
>
  <!------------------------------------------ btns ------------------------------------------>
  <div class="card-toolbar" before-btns>
    <!-- chart btn-->
    <a
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      mat-ripple
      [matTooltip]="'common.chart' | translate"
      (click)="onShowCharts()"
    >
      <i class="mdi mdi-chart-arc mdi-20px tw-p-0 text-purple"></i>
    </a>

    <!-- excel btn -->
    <button
      [disabled]="(items$ | async)?.length == 0"
      (click)="onExcelReport()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'common.downloadExcel' | translate"
    >
      <i class="mdi mdi-download mdi-20px tw-p-0 text-info"></i>
    </button>

    <!-- table excel btn -->
    <button
      [disabled]="(items$ | async)?.length == 0"
      (click)="onTableExcelReport()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'pages.sendSmartSMS.smartSmsDetailTableExcel' | translate"
    >
      <i class="mdi mdi-download mdi-20px tw-p-0 text-primary"></i>
    </button>

    <!-- refresh btn -->
    <a
      class="btn btn-light txt-lg button-shadow tw-mx-1 text-blue btn-hover-rise d-print-none"
      mat-ripple
      [matTooltip]="'common.refresh' | translate"
      (click)="onRefresh()"
    >
      <i class="mdi mdi-refresh mdi-20px tw-p-0 text-blue"></i>
    </a>
  </div>

  <div class="tw-flex tw-justify-between tw-items-center tw-ml-5" title>
    (
    <span
      class="tw-font-medium tw-text-base tw-text-gray-700 dark:tw-text-gray-300"
      >{{ "common.title" | translate }} :
    </span>
    <span
      copyToClipboard
      class="text-navyBlue tw-py-1 rounded tw-text-xl tw-mr-2 tw-font-semibold"
      >{{ campaignTitle.toString().replaceAll("+", " ") }}</span
    >
    )
  </div>

  <!----------------------------------------- Table Content ----------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- title -->
        <td>
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>

        <!-- operator -->
        <td class="tw-w-24">
          <div
            class="tw-flex-center"
            [matTooltip]="item?.operator | enumToText : SmsAggregatorEnumValues"
            [mobileOperatorImg]="{
              mobileOperator: item?.operator,
              mobileOperatorEnumValue:
                item?.operator | enumToText : SmsAggregatorEnumValues
            }"
          ></div>
        </td>

        <!-- numbersCount -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.numbersCount"
            type="number"
          ></td-value>
        </td>

        <!-- persianPrice -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.persianPrice"
            type="number"
          ></td-value>
        </td>

        <!-- englishPrice -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.englishPrice"
            type="number"
          ></td-value>
        </td>

        <!-- totalSmsCount -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.statistics?.totalSmsCount"
            type="number"
          ></td-value>
        </td>

        <!-- totalPartCount -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.statistics?.totalPartCount"
            type="number"
          ></td-value>
        </td>

        <!-- receivedMessage -->
        <td>
          <td-value copyToClipboard [value]="item?.receivedMessage"></td-value>
        </td>

        <!-- status -->
        <td style="max-width: 200px">
          <span>
            {{ item?.status | enumToText : SmartSmsStatusEnumValues }}</span
          >
        </td>

        <!-- statusDatetime -->
        <td class="dir-ltr">
          <td-value type="dateTime" [value]="item?.statusDatetime"></td-value>
        </td>

        <!-- expireTime -->
        <td>
          <td-value type="dateTime" [value]="item?.expireTime"></td-value>
        </td>

        <!--startDateTime-->
        <td class="dir-ltr">
          <td-value type="dateTime" [value]="item?.startDateTime"></td-value>
        </td>

        <!--endDateTime-->
        <td class="dir-ltr">
          <td-value type="dateTime" [value]="item?.endDateTime"></td-value>
        </td>

        <!------------------------------------ operations ------------------------------------>
        <td class="sticky-td">
          <!-- detail -->
          <a
            (click)="
              onShowDetailsByDelivery(
                item?.statistics?.items,
                item?.scheduledMessageDetails
              )
            "
            class="btn btn-sm"
            [matTooltip]="'common.detail' | translate"
          >
            <i
              class="mdi mdi-text-box-search-outline mdi-20px tw-p-0 text-blue"
            ></i>
          </a>
        </td>
      </tr>
    </ng-container>
    <tr class="tw-py-2 total-sum" *ngIf="!this.pageConfig.isEmpty">
      <td class="tw-text-center !tw-py-3 tw-text-gray-600" colspan="1">
        {{ "common.totalSum" | translate }}
      </td>
      <td class="tw-px-2 tw-text-center tw-text-gray-800 tw-font-medium">
        {{ totalNumbersCount | numberSeparator }}
      </td>
      <td class="tw-text-center" [attr.colspan]="13"></td>
    </tr>
  </ng-container>
</app-page-template>

<app-send-details-stats
  *ngIf="showCharts"
  [data]="data"
  (closeFormPage)="onCloseCharts()"
></app-send-details-stats>
